const pricings = {
	features: ["One end project", "12 months updates", "6 months support", "Typescript version", "Design assets", "Commercial applications"],

	values: [
		{
			index_value: [1, 1, 1, 0, 0, 0],
			link: "https://mui.com/store/items/carpatin-dashboard",
			name: "Standard",
		},
		{
			name: "Standard Plus",
			index_value: [1, 1, 1, 1, 1, 0],
			link: "https://mui.com/store/items/carpatin-dashboard",
		},
		{
			name: "Extended",
			index_value: [1, 1, 1, 1, 1, 1],
			link: "https://mui.com/store/items/carpatin-dashboard",
		},
	],
};

export default pricings;
